
export default function ComparisonSection() {
  const comparisonData = [
    {
      category: '初期準備',
      diy: '物件調査、許可申請、インテリア準備など、すべて自分で対応（数週間〜数ヶ月）',
      magome: '許可申請サポート、インテリアコーディネート、写真撮影まで一括対応'
    },
    {
      category: '日々の運営',
      diy: 'ゲスト対応、清掃手配、トラブル対応など、24時間365日自分で対応',
      magome: '予約管理からゲスト対応、清掃手配まで完全代行。オーナー様の負担ゼロ'
    },
    {
      category: '収益性',
      diy: '価格設定や稼働率の最適化が難しく、収益が不安定になりがち',
      magome: '平均稼働率92%、データに基づく価格最適化で安定した収益を実現'
    },
    {
      category: 'トラブル対応',
      diy: '深夜のトラブルや緊急時も自分で対応。精神的負担が大きい',
      magome: '24時間サポート体制。トラブル時も経験豊富なスタッフが即座に対応'
    },
    {
      category: '時間的コスト',
      diy: '月20〜40時間の運営業務が必要。本業や家族との時間が削られる',
      magome: '運営業務はすべて代行。オーナー様は収益を受け取るだけ'
    },
    {
      category: '専門知識',
      diy: '法律、税務、マーケティングなど、すべて自分で学ぶ必要がある',
      magome: '民泊運営のプロが最新の法規制やトレンドに基づいて運営'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            自分でやる vs プロに任せる
          </h2>
          <p className="text-lg text-gray-600">
            民泊運営を自分で行う場合と、Magome Kominkaに依頼する場合の違い
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200">
                  <th className="px-8 py-6 text-left text-sm font-bold text-gray-900 w-1/4">
                    項目
                  </th>
                  <th className="px-8 py-6 text-left text-sm font-bold text-gray-700 w-3/8">
                    自分で運営する場合
                  </th>
                  <th className="px-8 py-6 text-left text-sm font-bold text-teal-600 w-3/8 bg-teal-50">
                    Magome Kominkaに依頼する場合
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((item, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
                  >
                    <td className="px-8 py-6 font-semibold text-gray-900 align-top">
                      {item.category}
                    </td>
                    <td className="px-8 py-6 text-gray-600 align-top">
                      <div className="flex items-start gap-3">
                        <i className="ri-close-circle-line text-xl text-red-500 flex-shrink-0 mt-0.5"></i>
                        <span className="text-sm leading-relaxed">{item.diy}</span>
                      </div>
                    </td>
                    <td className="px-8 py-6 text-gray-800 align-top bg-teal-50/30">
                      <div className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-line text-xl text-teal-600 flex-shrink-0 mt-0.5"></i>
                        <span className="text-sm leading-relaxed font-medium">{item.magome}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-12 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-10 text-center text-white">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold mb-4">
              時間と労力を節約し、安定した収益を実現
            </h3>
            <p className="text-teal-50 mb-8 leading-relaxed">
              民泊運営には専門知識と多くの時間が必要です。Magome Kominkaに任せることで、オーナー様は本業や家族との時間を大切にしながら、安定した収益を得ることができます。
            </p>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-10 py-4 bg-white text-teal-600 rounded-full font-bold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer shadow-lg"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              無料相談を予約する
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
